var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5734 3.87361C12.7738 2.67391 14.4018 2 16.0992 2C17.7967 2 19.4247 2.67391 20.6251 3.87361C21.8255 5.07332 22.5 6.70058 22.5 8.39743C22.5 10.0941 21.8256 11.7213 20.6254 12.9209C20.6253 12.921 20.6255 12.9208 20.6254 12.9209L14.2817 19.2797C14.141 19.4207 13.95 19.5 13.7508 19.5H5.75C5.33579 19.5 5 19.1642 5 18.75V10.7539C5 10.5549 5.07908 10.3641 5.21983 10.2234L11.5734 3.87361ZM16.0992 3.5C14.7993 3.5 13.5528 4.01608 12.6337 4.93458L6.5 11.0647V18H13.4396L19.5648 11.8603C20.4838 10.9418 21 9.69617 21 8.39743C21 7.09869 20.4838 5.85306 19.5648 4.93458C18.6457 4.01608 17.3991 3.5 16.0992 3.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2803 8.21967C16.5732 8.51256 16.5732 8.98744 16.2803 9.28033L3.28033 22.2803C2.98744 22.5732 2.51256 22.5732 2.21967 22.2803C1.92678 21.9874 1.92678 21.5126 2.21967 21.2197L15.2197 8.21967C15.5126 7.92678 15.9874 7.92678 16.2803 8.21967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.75C9 14.3358 9.33579 14 9.75 14H17.75C18.1642 14 18.5 14.3358 18.5 14.75C18.5 15.1642 18.1642 15.5 17.75 15.5H9.75C9.33579 15.5 9 15.1642 9 14.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/Writing.c8f76a8d9e763e744186ed3b466e23f5.svg";
export { ForwardRef as ReactComponent };